// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"yfa-z"};